// extracted by mini-css-extract-plugin
export default {"toast":"App_toast__Mt+5G","toast-body":"App_toast-body__VEWVx"};